module.exports = __webpack_public_path__ + "img/menuIcon13.75e6e3c1.png";